module.exports = __webpack_public_path__ + "static/media/pkg_item1.0b61edde.jpg";